<template>
    <div id="app">
        <app-navbar v-if="$route.name !== 'magazine'"></app-navbar>
        <router-view></router-view>
    </div>
</template>

<script>
import Navbar from './components/Navbar'
import { serialize } from './functions.js'

function getWeekNumber (d) {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
    var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
    return [d.getUTCFullYear(), weekNo]
}

export default {
    data () {
        return {
        }
    },
    head: {
        meta: [
            { name: 'title', content: 'Howrly - Login' },
            { name: 'description', content: 'Welcome back at Howrly. Login here to see your available tasks and check your latest analytics.' }
        ]
    },
    components: {
        appNavbar: Navbar
    },
    created () {
        if (this.$route.name !== 'magazine' && this.$route.name !== 'user-reset-password') {
            // console.log('Refresh tokens')
            this.$auth.refreshTokens()
            if (this.$auth.isAccessTokenValid()) {
                // console.log('Token valid so set interval')
                setInterval(this.$auth.refreshTokens, 300000)
            }
            let promiseList = [this.$store.dispatch('general/getOrganisation'), this.$store.dispatch('budget/getLevels')]
            Promise.all(promiseList)
                .then(response => {
                //
                })
                .catch(error => {
                    console.log(error)
                })
        }
        if (this.$route.name !== 'budget-budget' && this.$route.name !== 'user-reset-password' && this.$route.name !== 'magazine' && this.$auth.isAccessTokenValid()) {
            // Already load budget and predictions for current week,year and level 1
            this.$store.dispatch('budget/getBudget', { 'route': serialize({ level: 1, year: getWeekNumber(new Date())[0], week: getWeekNumber(new Date())[1] }) + '&org_id=' + localStorage.getItem('org_id') + '&context=true' })
                .then(response => {
                //
                })
                .catch(error => {
                    console.log(error)
                })
            this.$store.dispatch('budget/getPrediction', { 'route': serialize({ level: 1, year: getWeekNumber(new Date())[0], week: getWeekNumber(new Date())[1] }) + '&org_id=' + localStorage.getItem('org_id') + '&context=true' })
                .then(response => {
                //
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    mounted () {
        this.$store.commit('general/SET_WINDOW_WIDTH', window.innerWidth)
        window.addEventListener('resize', () => {
            this.$store.commit('general/SET_WINDOW_WIDTH', window.innerWidth)
        })
    }
}
</script>

<style lang="scss">
</style>
